export function characterCounter(obj) {
    const maxLength = 250;
    const strLength = obj.value.length;
    let counterElement = document.querySelector(".characterCounter");

    if(!counterElement){
       counterElement = initCharacterCounter(obj)
    }

    counterElement.innerHTML = strLength + '/' + maxLength;
    counterElement.classList.toggle("exceedsMaxChar", strLength >= maxLength);
}

function initCharacterCounter(obj){
    const newDiv = document.createElement("div");
    newDiv.classList.add("characterCounter");
    obj.after(newDiv);

    return document.querySelector(".characterCounter");
}
